/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const shareGrantPermissionsMax = 6;

export const ShareGrant = zod.object({
  expiresAt: zod.iso
    .datetime({ offset: true })
    .nullish()
    .describe(
      'When the grant ends (checked by calendar day). Omitted: an existing grant keeps its expiry and a new one has none. null: no expiry.',
    ),
  permissions: zod
    .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
    .min(1)
    .max(shareGrantPermissionsMax)
    .describe(
      'Stored as the highest rung named: READ < SHARE < COPY < CONTRIBUTE < EDIT < DELETE (Viewer = READ+SHARE+COPY, Contributor = CONTRIBUTE, Editor = EDIT). PUBLIC allows at most Contributor: EDIT or DELETE for everyone is a 400 PUBLIC_PERMISSION_CEILING.',
    ),
  principalType: zod
    .enum(['USER', 'GROUP', 'GROUP_MEMBERS', 'PUBLIC'])
    .describe(
      'Who the grant is for: one person (USER), a group acting as itself (GROUP), everyone in a group (GROUP_MEMBERS), or everyone (PUBLIC).',
    ),
  principalUuid: zod.uuid().optional().describe('The user or group; omitted for PUBLIC.'),
});

export type ShareGrant = zod.input<typeof ShareGrant>;
export type ShareGrantOutput = zod.output<typeof ShareGrant>;
